import { Outlet, createFileRoute } from "@tanstack/react-router";
import { BarLineChart } from "@untitled-ui/icons-react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import { type ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/_panel/_chart")({
  component: Component,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("chart", context.tenant.modules);

    return {
      title: () => context.t("Organization chart", { ns: "chart.shared" }),
      crumb: [
        {
          Icon: BarLineChart,
        },
        {
          label: context.t("Organization chart", { ns: "chart.shared" }),
          link: { to: "/chart/charts/$type" },
        },
      ],
    } satisfies ChildRouteContext;
  },
  pendingComponent: TableSkeleton,
});

function Component() {
  return <Outlet />;
}
